import { FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';
import { Modal } from '../../../components/Modal/Modal.component';
import { ExamTaskGroupCoordinator } from '../../../models/taskGroup.types';
import { useTranslation } from 'react-i18next';

/**
 * ExamTaskGroupCoordinatorDialogProps is a component used for selection of:
 * KGZ (Exam Task Group Coordinator) who will be assigned as ZWO (Sample Assessment Group Chairman)
 */
interface SelectExamTaskGroupCoordinatorDialogProps {
  open: boolean;
  taskGroupCoordinators: ExamTaskGroupCoordinator[];
  isSampleAssessmentGroupJustCreated?: boolean;
  taskGroupId: string;
  onSelect: (selectedTaskGroupCoordinator: ExamTaskGroupCoordinator) => void;
  onCancel: () => void;
}

export const SelectExamTaskGroupCoordinatorDialog: React.FC<SelectExamTaskGroupCoordinatorDialogProps> = (props) => {
  const { t } = useTranslation();
  const [taskGroupCoordinator, setTaskGroupCoordinator] = useState<ExamTaskGroupCoordinator | undefined>(
    props.taskGroupCoordinators.length === 1 ? props.taskGroupCoordinators[0] : undefined,
  );
  const [selectedGroupCoordinatorId, setSelectedGroupCoordinatorId] = useState<string>('');
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const coordinator = props.taskGroupCoordinators.find(
      (coordinator) => coordinator.taskGroupCoordinatorId === (event.target.value as string),
    );
    setSelectedGroupCoordinatorId(coordinator ? coordinator.taskGroupCoordinatorId : '');
    setTaskGroupCoordinator(coordinator);
  };

  const onLeave = () => {
    setTaskGroupCoordinator(undefined);
  };

  const onCancel = () => {
    onLeave();
    props.onCancel();
  };

  return (
    <Modal id={props.taskGroupId} open={props.open} size="sm" autoHeight>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{
          rowGap: '50px',
          padding: '25px',
        }}
      >
        <Grid item xs={12}>
          <Typography variant="h6" noWrap>
            Wybierz KGZ jako Przewodniczącego ZWO:
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <FormControl fullWidth variant="outlined">
            <InputLabel id="task-group-coordinator-select-label">Wybierz przewodniczącego ZWO*</InputLabel>
            <Select
              labelId="task-group-coordinator-select-label"
              label="Wybierz przewodniczącego ZWO*"
              value={selectedGroupCoordinatorId}
              onChange={handleChange}
            >
              {props.taskGroupCoordinators.map((coordinator) => (
                <MenuItem disableRipple key={coordinator.taskGroupCoordinatorId} value={coordinator.taskGroupCoordinatorId}>
                  {coordinator.examiner.firstName + ' ' + coordinator.examiner.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={4}>
          <ButtonOne variant="outlined" color="primary" style={{ minWidth: '140px' }} onClick={onCancel}>
            Anuluj
          </ButtonOne>
        </Grid>
        <Grid item xs={4}>
          <ButtonOne
            variant="contained"
            color="primary"
            style={{ minWidth: '140px' }}
            onClick={() => {
              if (taskGroupCoordinator) props.onSelect(taskGroupCoordinator);
            }}
            disabled={!selectedGroupCoordinatorId}
          >
            Zapisz
          </ButtonOne>
        </Grid>
      </Grid>
    </Modal>
  );
};
